import { Link } from "react-router-dom"

function Navbar(props) {
    return (
        <nav className="nav-bar">
            <Link to="/">
                <img className="nav-image" src="../favicon.ico" alt="navigation" />
            </Link>
            <h1 className="nav-title">{props.title}</h1>
            {props.showFilter &&
                <button 
                onClick={props.handleClick}
                className="streaming-service-filter-button light-background-color">
                    Streaming Services
                </button>}
        </nav>
    )
}

export default Navbar
